import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PasswordInput } from '@/components/ui/password-input';

interface AuthInputProps {
  id: string;
  type: string;
  label: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  autoComplete?: string;
  autoCapitalize?: string;
  autoCorrect?: string;
}

export function AuthInput({
  id,
  type,
  label,
  placeholder,
  value,
  onChange,
  required = true,
  autoComplete,
  autoCapitalize,
  autoCorrect,
}: AuthInputProps) {
  const InputComponent = type === 'password' ? PasswordInput : Input;
  const inputProps = {
    id,
    placeholder,
    required,
    value,
    onChange,
    autoComplete,
    autoCapitalize,
    autoCorrect,
    className: 'h-12',
    ...(type !== 'password' && { type }),
  };

  return (
    <div className="grid gap-2">
      <Label htmlFor={id}>{label}</Label>
      <InputComponent {...inputProps} />
    </div>
  );
}
